<template>
    <div class="customers-learning">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />
        
        <time-usage v-show="selectedItem === 'timeUsage'" />
        <time-usage-skills v-show="selectedItem === 'timeUsageSkills'" />
        <employee-revenue v-show="selectedItem === 'employeeRevenue'" />
        <efficiency-graph v-show="selectedItem === 'efficiencyGraph'" />
        
    </div>
</template>

<script>

export default {
    data () {
        return {
            selectedItem: 'timeUsageSkills',
            counts: {},
            switchItems: [
                {
                    name: 'Hvor gode er vi til at registrere tid?',
                    slug: 'timeUsageSkills'
                },
                {
                    name: 'Hvad bruger vi tiden på?',
                    slug: 'timeUsage'
                },
                {
                    name: 'Hvordan er medarbejdernes indtjening?',
                    slug: 'employeeRevenue'
                },
                {
                    name: 'Hvor meget tid bruger svendene hos kunderne?',
                    slug: 'efficiencyGraph'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            })
        }
    },
    mounted () {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab
        }
        this.$store.state.view = 'learning'
    },
    components: {
        'employee-skills': require('./learning/employeeSkills.vue'),
        'time-usage': require('./learning/timeUsage.vue'),
        'time-usage-skills': require('./learning/timeUsageSkills.vue'),
        'employee-revenue': require('./learning/employeeRevenue.vue'),
        'efficiency-graph': require('./learning/efficiencyGraph.vue')
    }
}
</script>



// WEBPACK FOOTER //
// learning.vue?7a2dfe6e